import React, { useState } from 'react';
import { ReactModal } from '@parts';

const WarrantyWidget = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="warranty-widget">
      <button className="button" onClick={() => setShowModal(!showModal)}>
        Shop with Confidence - Salt Warranty
      </button>
      <ReactModal className="warranty-modal" showModal={showModal} setShowModal={setShowModal}>
        <h4>Acrylic Products</h4>
        <p>
          Our comprehensive manufacturing warranty ensures that your acrylic product arrives in pristine condition. Our premium acrylic is
          chemical free, antimicrobial and designed to last. We cover any acrylic products that have arrived damaged, including cracks,
          chips, or parts coming unglued. If you have received any acrylic products with damage, notify us as soon as possible. Please
          provide clear pictures and a description of the damage and our team will work to get an expedited replacement.
        </p>
      </ReactModal>
    </div>
  );
};

export default WarrantyWidget;
